import { CIAMConfig, configMap } from '../types';
import axios from 'axios';
import { v4 as UUID } from 'uuid';

export const getRouterUrl = (config: CIAMConfig): string => {
  const env = getEnv(config);
  if((env.startsWith("it")|| env.startsWith("dev")) && config.internalUrl) {
    const domain = window.location.origin;
    const ciamHost = domain.includes('us.bank-dns.com') ? `https://${env}-ciam.us.bank-dns.com` : `https://${env}.login.elavon.com`;
    return `${ciamHost}/v1/api/router/`;
  }
  return configMap[getEnv(config)].HANDLE_ROUTE;
};

export const getSessionSupportUrl = (config: CIAMConfig): string => {
  const env = getEnv(config);
  if((env.startsWith("it")|| env.startsWith("dev")) && config.internalUrl) {
    const domain = window.location.origin;
    const ciamHost = domain.includes('us.bank-dns.com') ? `https://${env}-ciam.us.bank-dns.com` : `https://${env}.login.elavon.com`;
    return `${ciamHost}/v1/api/sessionsupport/`;
  }
  return configMap[getEnv(config)].SESSION_SUPPORT;
};

export const getEnv = (config: CIAMConfig): 'dev'|'it'|'it2'|'uat'|'prod'|'local'  => {
  if(config.env) {
    if(config.env.startsWith("dev")) return "dev";
    if(config.env.startsWith("it2")) return "it2";
    if(config.env.startsWith("it")) return "it";
    if(config.env.startsWith("uat")) return "uat";
    if(config.env.startsWith("prod")|| config.env.startsWith("prd")) return "prod";
    return "local";
  }
  return "it";
}

export const getSession = async (jwtToken: string, url: string) => {
  const configInit: any = getApiConfig(jwtToken);
  configInit.method = 'GET';
  const resp = await axios.get(url, configInit);
  return resp;
};

export const refreshCookie = async (jwtToken: string, url: string) => {
  const configInit: any = getApiConfig();
  configInit.withCredentials = true;
  configInit.method = 'POST';
  const body = { jwtToken: jwtToken };
  const resp = await axios.post(url + 'refreshCookie', body, configInit);
  console.log('Refresh cookie Done: ', resp);
  return resp;
};

export const refreshSession = async (jwtToken: string, url: string) => {
  const configInit: any = getApiConfig(jwtToken);
  configInit.method = 'POST';
  const resp = await axios.post(url + 'user-session/refresh', {}, configInit);
  console.log('Refresh Session Done: ', resp);
  return resp;
};

export const logoutSession = async (jwtToken: string, url: string) => {
  const configInit: any = getApiConfig(jwtToken);
  configInit.method = 'POST';
  const resp = await axios.post(url + 'user-session/log-out', {}, configInit);
  console.log('Logout Session Done: ', resp);
  return resp;
};

export const deleteCookies = async(jwtToken: string, url: string) => {
  const configInit: any = getApiConfig();
  configInit.withCredentials = true;
  configInit.method = 'POST';
  const body = { jwtToken };
  const resp = await axios.post(url + 'deleteCookies', body, configInit);
  console.log('Delete cookie Done: ', resp);
  return resp;
}

export const Constants = {
  AUTH: {
    APP_KEY: '3eVYJfbOuOG2acIb2mg9Wn264d9PMTAh',
    APP_ID: 'ciam_mps_web',
    POLICY: 'login',
    LOGIN_APP_VERSION: '1',
    LOGIN_HELP_APP_VERSION: 'loginhelp-atg-1.0',
    APPLICATION_ID: 'CIAM_MPS',
    USE_CASE: 'login',
  },
  TENANT: {
    ID: 'ELAVON',
    CHANNEL: 'web',
  },
  DISPLAY_FIELD: {
    SHOW: 'show',
    HIDE: 'hide',
  },
  PROFILE: {
    X_DATA_REQUESTED: false,
  },
};

const getApiConfig = (bearerToken?: string) => {
  return {
    // withCredentials: true,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Correlation-Id': 'manual-id',
      Authorization: bearerToken ? 'Bearer ' + bearerToken : undefined,
    },
  };
};

export const getCorrelationId = (): string => {
  if(sessionStorage.getItem("InteractionID")) {
    return sessionStorage.getItem("InteractionID") as string;
  }
  return UUID();
}

export const parseCookieString = (cookieString: string): { [key: string]: string } =>{
  const cookiePairs: { [key: string]: string } = {};
  cookieString.split(";").forEach(cookie => {
    const [key, value] = (() => {
        const index = cookie.indexOf("=");
        if (index === -1) return [cookie.trim(), ""];
        return [cookie.slice(0, index).trim(), cookie.slice(index + 1).trim()];
    })();
    if (key && value !== undefined) {
      cookiePairs[key] = value;
    }
  });
  return cookiePairs;
}

export const convertStringToObject = (rawString: string) => {
  const decoded = decodeURIComponent(rawString.replace(/&amp;/g, "&"));
  const params = new URLSearchParams(decoded);
  const sessionData: { [key: string]: any } = {};

  params.forEach((value, key) => {
    sessionData[key] = value === 'true' ? true :
                    value === 'false' ? false :
                    value;
  });
 return sessionData;
}

export const parseUserData = (encodedStr: string): Record<string, string>[] => {
  const decodedStr = decodeURIComponent(encodedStr.replace(/&amp;/g, '&'));
  const pairs = decodedStr.split('&');
  const users: any = {};

  for (const pair of pairs) {
    if (pair.startsWith('length=')) continue;
    if(pair.includes('=') === false) continue; // Skip if no '=' found
    const [rawKey, value] = pair.split(/=(.+)/).filter(Boolean);
    const match = rawKey.match(/^(\d+)\[([^\]]+)\]$/);

    if (match) {
      const index = parseInt(match[1], 10);
      const key = match[2];

      if (!users[index]) {
        users[index] = {};
      }

      const decodedValue = decodeURIComponent(value || '');
      users[index][key] = decodedValue === 'true' ? true :
                    decodedValue === 'false' ? false :
                    decodedValue;
    }
  }
  users.length = Object.keys(users)?.length;
  return users;
}

export const  addQueryParamsIfMissing = (urlString: string, newParams: Record<string, string>): string  => {
  try {
    const url = new URL(urlString);
    const params = url.searchParams;

    for (const [key, value] of Object.entries(newParams)) {
      if (!params.has(key)) {
        params.append(key, value);
      }
    }

    return url.toString();
  } catch(e) {
    console.error(e); 
    return '';
  }
  
}

export const toURLEncoded = (obj: any, prefix?: string) => {
  if (obj === null || typeof obj !== 'object') {
    return '';
  }
  const queryString: any = Object.keys(obj)
    .map((key) => {
      const value = obj[key];
      const encodedKey = prefix
        ? `${prefix}[${encodeURIComponent(key)}]`
        : encodeURIComponent(key);

      if (typeof value === 'object' && value !== null) {
        return toURLEncoded(value, encodedKey);
      } else {
        return `${encodedKey}=${encodeURIComponent(value)}`;
      }
    })
    .join('&');

  return queryString;
};
